import React from "react";
import { useNavigate } from "react-router-dom";
import { FaShareAlt, FaRegCalendarAlt, FaCoins, FaArrowRight } from "react-icons/fa";
import classes from "./GrantlarVaLoyihalar.module.css";
import {
  getLabels,
  normLang,
  pick,
  formatDate,
  daysLeft,
  flagUrl,
  imgUrl,
  shareLink,
} from "./grantUtils";

// Muddat holati: rang va matn
export const deadlineState = (left, L) => {
  if (left === null) return { text: null, tone: "none" };
  if (left < 0) return { text: L.expired, tone: "expired" };
  if (left === 0) return { text: L.lastDay, tone: "urgent" };
  if (left <= 7) return { text: L.daysLeft(left), tone: "urgent" };
  if (left <= 30) return { text: L.daysLeft(left), tone: "soon" };
  return { text: L.daysLeft(left), tone: "ok" };
};

const GrantCard = ({ item, lang, onToast }) => {
  const navigate = useNavigate();
  const L = getLabels(lang);

  const title = pick(item, "title", lang);
  const country = pick(item, "country", lang);
  const funding = pick(item, "funding", lang);
  const flag = flagUrl(item.country_code);
  const left = daysLeft(item.deadline);
  const expired = left !== null && left < 0;
  const state = deadlineState(left, L);

  const detailPath = `/grantlar/${item.id}`;

  const handleShare = async (e) => {
    e.stopPropagation();
    const url = `${window.location.origin}/${normLang(lang)}${detailPath}`;
    const result = await shareLink(url, title);
    if (result === "copied" && onToast) onToast(L.copied);
  };

  return (
    <article
      className={`${classes.card} ${expired ? classes.cardExpired : ""}`}
      onClick={() => navigate(detailPath)}
      role="link"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && navigate(detailPath)}
    >
      {/* Rasm */}
      <div className={classes.media}>
        <img src={imgUrl(item.image)} alt={title} className={classes.image} loading="lazy" />
        <div className={classes.mediaShade} />

        {(country || flag) && (
          <span className={classes.country}>
            {flag && (
              <img
                src={flag}
                alt=""
                className={classes.flag}
                onError={(e) => (e.currentTarget.style.display = "none")}
              />
            )}
            {country}
          </span>
        )}

        <button
          type="button"
          className={classes.share}
          onClick={handleShare}
          title={L.share}
          aria-label={L.share}
        >
          <FaShareAlt />
        </button>

        {expired && <span className={classes.expiredBadge}>{L.expired}</span>}
      </div>

      {/* Matn qismi */}
      <div className={classes.body}>
        <h3 className={classes.title} title={title}>
          {title}
        </h3>

        <div className={classes.stats}>
          <div className={classes.stat}>
            <span className={`${classes.statIcon} ${classes.statIconFunding}`}>
              <FaCoins />
            </span>
            <div className={classes.statText}>
              <span className={classes.statLabel}>{L.funding}</span>
              <span className={classes.statValue} title={funding}>
                {funding || "—"}
              </span>
            </div>
          </div>

          <div className={classes.stat}>
            <span className={`${classes.statIcon} ${classes.statIconDeadline}`}>
              <FaRegCalendarAlt />
            </span>
            <div className={classes.statText}>
              <span className={classes.statLabel}>{L.deadline}</span>
              <span className={classes.statRow}>
                <span
                  className={`${classes.statValue} ${
                    item.deadline && !expired ? classes.statValueDeadline : ""
                  }`}
                >
                  {item.deadline ? formatDate(item.deadline, lang) : L.noDeadline}
                </span>
                {state.text && (
                  <span className={`${classes.pill} ${classes[`pill_${state.tone}`]}`}>
                    {state.text}
                  </span>
                )}
              </span>
            </div>
          </div>
        </div>

        <div className={classes.cardFooter}>
          <span className={classes.more}>
            {L.details} <FaArrowRight />
          </span>
        </div>
      </div>
    </article>
  );
};

export default GrantCard;
